import { createSelector } from 'reselect';
import requestStatusTypes from '../../constants/requestStatusTypes';
import { List as ImmutableList } from 'immutable';
import { subAppKeysByTemplateKey
// @ts-expect-error Untyped import
} from 'sales-analytics-lib/utils/get-report-config';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { getRecentlyUpdatedTemplates } from '../../api/reportTemplatesApi';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
// @ts-expect-error Untyped import
import { updateCustomFiltersInTemplate } from '../../utils/srvMigrationUtils';
import { getJourneyWithValidChartType } from '../../utils/journeyGenerationUtils';
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusTypes;
export const recentlyUpdatedTemplatesNamespace = 'recentlyUpdatedTemplates';
// Action types
const ACTION_TYPES = {
  FETCH_RECENTLY_UPDATED_TEMPLATES_PENDING: 'FETCH_RECENTLY_UPDATED_TEMPLATES_PENDING',
  FETCH_RECENTLY_UPDATED_TEMPLATES_SUCCEEDED: 'FETCH_RECENTLY_UPDATED_TEMPLATES_SUCCEEDED',
  FETCH_RECENTLY_UPDATED_TEMPLATES_FAILED: 'FETCH_RECENTLY_UPDATED_TEMPLATES_FAILED'
};
// Actions
export const fetchRecentlyUpdatedTemplates = () => (dispatch, getState) => {
  const state = getState();
  if ([SUCCEEDED, PENDING].includes(state[recentlyUpdatedTemplatesNamespace].status)) {
    return Promise.resolve();
  }
  const {
    scopes
  } = getGatesAndScopes(state);
  dispatch({
    type: ACTION_TYPES.FETCH_RECENTLY_UPDATED_TEMPLATES_PENDING
  });
  return getRecentlyUpdatedTemplates().then(response => {
    const results = (response === null || response === void 0 ? void 0 : response.get('results')) || ImmutableList();
    const processedTemplates = [];
    results.forEach(template => {
      const templateKey = template.get('templateKey');
      const subAppKey = subAppKeysByTemplateKey.get(templateKey);
      let templateReport = template.remove('id');
      if (isJourneyReport(templateReport)) {
        templateReport = getJourneyWithValidChartType(templateReport, scopes);
      }
      if (subAppKey === SUB_APPS.changeHistoryDealList) {
        templateReport = updateCustomFiltersInTemplate(templateReport);
      }
      processedTemplates.push(templateReport);
    });
    dispatch({
      type: ACTION_TYPES.FETCH_RECENTLY_UPDATED_TEMPLATES_SUCCEEDED,
      payload: processedTemplates
    });
  }, error => {
    console.error(error); // eslint-disable-line no-console
    dispatch({
      type: ACTION_TYPES.FETCH_RECENTLY_UPDATED_TEMPLATES_FAILED,
      payload: error
    });
  });
};

// Reducers
const initialState = {
  recentlyUpdatedTemplates: [],
  status: UNINITIALIZED
};
export const recentlyUpdatedTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_RECENTLY_UPDATED_TEMPLATES_PENDING:
      return Object.assign({}, state, {
        status: PENDING
      });
    case ACTION_TYPES.FETCH_RECENTLY_UPDATED_TEMPLATES_SUCCEEDED:
      {
        return Object.assign({}, state, {
          status: SUCCEEDED,
          recentlyUpdatedTemplates: action.payload
        });
      }
    case ACTION_TYPES.FETCH_RECENTLY_UPDATED_TEMPLATES_FAILED:
      return Object.assign({}, state, {
        status: FAILED
      });
    default:
      return state;
  }
};

// Selectors
export const selectRecentlyUpdatedTemplatesRoot = state => state[recentlyUpdatedTemplatesNamespace];
export const selectRecentlyUpdatedTemplates = createSelector(selectRecentlyUpdatedTemplatesRoot, templatesRoot => templatesRoot.recentlyUpdatedTemplates);
const selectRecentlyUpdatedTemplatesRequestStatus = createSelector(selectRecentlyUpdatedTemplatesRoot, templatesRoot => templatesRoot.status);
export const selectIsRecentlyUpdatedTemplatesRequestPending = createSelector(selectRecentlyUpdatedTemplatesRequestStatus, status => [PENDING, UNINITIALIZED].includes(status));